import React, { useCallback, useEffect, useState } from 'react'

import { FlipCounter } from './styled'
import { FlipUnitContainer } from './components/flipUnitContainer'

const FlipClock = ({ endDate, onTimeOver, ...rest }) => {
  const calculateTimeLeft = useCallback(() => {
    const now = new Date()
    const difference = endDate - now
    if (difference <= 1000) {
      if (onTimeOver) {
        setTimeout(() => {
          onTimeOver()
        }, 1000)
      }
      return { days: 0, hours: 0, minutes: 0, seconds: 0 }
    }

    const seconds = Math.floor((difference / 1000) % 60)
    const minutes = Math.floor((difference / (1000 * 60)) % 60)
    const hours = Math.floor((difference / (1000 * 60 * 60)) % 24)
    const days = Math.floor(difference / (1000 * 60 * 60 * 24))

    return { days, hours, minutes, seconds }
  }, [endDate])

  const [time, setTime] = useState(calculateTimeLeft())

  const [shuffles, setShuffles] = useState({
    daysShuffle: true,
    hoursShuffle: true,
    minutesShuffle: true,
    secondsShuffle: true,
  })

  useEffect(() => {
    if (
      time.days === 0 &&
      time.hours === 0 &&
      time.minutes === 0 &&
      time.seconds === 0
    )
      return

    const timerID = setInterval(() => {
      const newTime = calculateTimeLeft()
      setTime(newTime)

      setShuffles((prevShuffles) => ({
        daysShuffle:
          newTime.days !== time.days
            ? !prevShuffles.daysShuffle
            : prevShuffles.daysShuffle,
        hoursShuffle:
          newTime.hours !== time.hours
            ? !prevShuffles.hoursShuffle
            : prevShuffles.hoursShuffle,
        minutesShuffle:
          newTime.minutes !== time.minutes
            ? !prevShuffles.minutesShuffle
            : prevShuffles.minutesShuffle,
        secondsShuffle:
          newTime.seconds !== time.seconds
            ? !prevShuffles.secondsShuffle
            : prevShuffles.secondsShuffle,
      }))
    }, 1000)

    return () => clearInterval(timerID)
  }, [time, endDate, calculateTimeLeft])

  return (
    <FlipCounter gap={rest?.card?.gap || 20}>
      {Object.keys(time).map((key, index) => {
        return (
          <FlipUnitContainer
            key={key}
            {...rest}
            isLast={Object.keys(time).length - 1 === index}
            unit={key}
            digit={time[key]}
            shuffle={shuffles[`${key}Shuffle`]}
          />
        )
      })}
    </FlipCounter>
  )
}

export default FlipClock
